const axios = require("axios");

export const getToken = () => {
  if (localStorage.getItem("keptLogged") == "true") {
    return localStorage.getItem("token") || null;
  }
  return sessionStorage.getItem("token") || null;
};

export const getAllWorkflows = async (limit, offSet, searchText) => {
  const response = await axios.get(
    searchText
      ? process.env.REACT_APP_API_BASE_URL +
          `workflows?limit=${limit}&offset=${offSet}&search=${searchText}`
      : process.env.REACT_APP_API_BASE_URL +
          `workflows?limit=${limit}&offset=${offSet}`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getWorkflowsCount = async (searchText) => {
  const response = await axios.get(
    searchText
      ? process.env.REACT_APP_API_BASE_URL +
          `workflows/count?search=${searchText}`
      : process.env.REACT_APP_API_BASE_URL + `workflows/count`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const getWorkflowLogs = async (id) => {
  const response = await axios.get(
    process.env.REACT_APP_API_BASE_URL + `workflows/${id}/logs`,
    {
      headers: {
        Authorization: "Bearer " + getToken(),
      },
    }
  );
  return response.data;
};

export const deleteWorkflow = async (id) => {
  const response = await axios({
    method: "delete",
    url: process.env.REACT_APP_API_BASE_URL + `workflows/${id}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  });
  return response.data;
};
export const cloneWorkflow = async (id) => {
  const response = await axios({
    method: "post",
    url: process.env.REACT_APP_API_BASE_URL + `workflows/${id}/clone`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  });
  return response.data;
};
export const getReport = async (id) => {
  const response = await axios({
    method: "get",
    url: process.env.REACT_APP_API_BASE_URL + `workflows/${id}/report `,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  });
  return response.data;
};

export const putWorkflowData = async (id, data) => {
  const response = await axios({
    method: "put",
    url: process.env.REACT_APP_API_BASE_URL + `workflows/${id}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
    data: data,
  });
  return response.data;
};

export const getWorkflowTemplates = async (offset, limit) => {
  const response = await axios({
    method: "get",
    url:
      process.env.REACT_APP_API_BASE_URL +
      `workflows/templates?offset=${offset}&limit=${limit}`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  });
  return response.data;
};

export const getWorkflowTemplatesCount = async () => {
  const response = await axios({
    method: "get",
    url: process.env.REACT_APP_API_BASE_URL + `workflows/templates/count`,
    headers: {
      Authorization: "Bearer " + getToken(),
    },
  });
  return response.data;
};
